@if (competitor) {
<ng-container *transloco="let t" class="container">
<div class="modal-body">
@if (isInModal) {
<div class="d-flex align-items-center pb-4">
  <img src="assets/img/svg/T.svg" alt="Tracey logo">
  <div class="d-flex align-items-start flex-grow-1">
    <div class="fw-semibold title-wrapper line-height-1">
      {{ title ? t(title) : "" }}
    </div>
  </div>
  <div class="pe-20 align-self-start">
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>
</div>
}

@if (isInModal) {
<div class="body-wrapper">
  <ng-template [ngTemplateOutlet]="form">
  </ng-template>
</div>
}
@else {
  <app-admin-card-with-title [cardTitle]="t('competitor.edit')" [removeTopMargin]="true" [showToggleButton]="true">
    <ng-template [ngTemplateOutlet]="form">

    </ng-template>
  </app-admin-card-with-title>

@if (race?.raceSettings?.teamType && race?.raceSettings?.teamType !== TeamType.SINGLE &&
(competitor?.teamMembers?.length ?? 0) > 0) {
  <app-admin-card-with-title [cardTitle]="t('competitor.team.members')" [showToggleButton]="true">
    <app-competitor-table [languages]="languages" (onEditTeamMemberButtonClick)="editTeamMember($event)"
      [raceSettings]="race?.raceSettings"
      [filteringEnabled]="false"
      [applicationFormSettings]="race?.applicationFormSettings"
      [tableMode]="CompetitorTableType.TEAM_MEMBER_VIEW"
      [showEmptyState]="true"
      [showHeader]="false"
      [raceCommercialItems]="raceCommercialItems"
      [raceAdditionalPricingItems]="raceAdditionalItems"
      [isTeamMembersManagement]="true"
      [isAdmin]="true"
      [genders]="genders"
      [countries]="countries"
      [event]="eventItem"
      [competitors]="competitor!.teamMembers ?? []"/>
  </app-admin-card-with-title>
  }
}

<ng-template #form>
<app-team-members-management-form [race]="race" [event]="eventItem" [teamMemberEdit]="false"
[competitor]="competitor" [raceSettings]="race?.raceSettings" [applicationFormSettings]="race?.applicationFormSettings"
[raceRegistration]="raceRegistration" [languages]="languages" [assignStartNumber]="assignStartNumber"
 [lookups]="filteredLists">
</app-team-members-management-form>
</ng-template>

@if (isInModal) {
<div class="d-flex justify-content-center align-items-center pb-40-48">
  <div class="d-flex">
    <div class="pe-3">
      <app-rounded-button [label]="t('app.common.cancel')" [btnClass]="'rounded-button--black-outline'" (onClick)="onCancel()"/>
    </div>
    <app-rounded-button [label]="t('app.common.save')" (onClick)="onCompetitorSave()" [btnClass]="'rounded-button--solid'"></app-rounded-button>
  </div>
</div>
}
@else {
<app-action-buttons-row (onSave)="onCompetitorSave()" (onCancel)="onCancel()"></app-action-buttons-row>
}
</div>
</ng-container>
}
